
import FormContainer from '@/components/processing_steps/commons/forms/FormContainer.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import CompletitionLayout from '@/components/processing_steps/commons/CompletitionLayout.vue'
import HdsCheckboxCross from "@/components/processing_steps/commons/fields/HdsCheckboxCross.vue"
import { IPSResultReport } from "@/types/processingSteps"
import SingleSelectField from "@/components/processing_steps/commons/fields/SingleSelectField.vue"
import { ISelectOption } from "@/types/base"

@Component({
  components: {
    SingleSelectField,
    HdsCheckboxCross,
    FormContainer,
    CompletitionLayout
  }
})
export default class PublishResultReportForm extends Vue {
  @Prop() uploadConfirmation!: boolean
  @Prop() fundUsageConfirmation!: boolean
  @Prop() isComplete!: boolean
  @Prop() summaryItems!: { title: string, items: { title: string, values: string[] }[]}[]
  @Prop() organizationTitle: string
  @Prop() resultReport!: IPSResultReport
  @Prop({ default: false }) isInForeignCountry: boolean
  @Prop({ default: false }) IsSiteAdmin: boolean

  resultReportStatusOptions: ISelectOption[] = [
    { value: null, text: this.$gettext('Choose a status') },
    { value: '1', text: this.$gettext('In progress') },
    { value: '2', text: this.$gettext('Complete') }
  ]

  resultReportReviewOptions: ISelectOption[] = [
    { value: '1', text: this.$gettext('Please choose…') },
    { value: '2', text: this.$gettext('Public') },
    { value: '3', text: this.$gettext('Rejected') },
    { value: '4', text: this.$gettext('Accepted') }
  ]

  mounted (): void {
    if (!this.isInForeignCountry) {
      this.$emit('uploadConfirmation', true)
      this.$emit('fundUsageConfirmation', true)
    }
  }

  get isCompleteAndDraft (): boolean {
    return (this.resultReport.review_status === 1 && this.isComplete && this.resultReport.status !== 2) || (!this.isInForeignCountry && this.isComplete && this.resultReport.status !== 2)
  }

  get isCompleteAndSubmitted (): boolean {
    return this.resultReport.status === 2 && this.resultReport.review_status === 1 && this.isComplete
  }

  get isCompleteAndAccepted (): boolean {
    return (this.resultReport.review_status === 2 || this.resultReport.review_status === 4) && this.isComplete
  }

  get statusExplanation (): string {
    if (this.isCompleteAndDraft) {
      return this.$gettext('The data for this results report is complete. You can submit the results report.')
    }
    if (this.isCompleteAndSubmitted) {
      return this.$gettext('This report is complete. Haus des Stiftens is currently reviewing the report.')
    }
    if (this.isCompleteAndAccepted) {
      return ""
    }
    return this.$gettext('The data for this results report is incomplete.')
  }

  get statusTitle (): string {
    if (this.isCompleteAndDraft) {
      return this.$gettext('Complete')
    }
    if (this.isCompleteAndSubmitted) {
      return this.$gettext('Under review')
    }
    if (this.isCompleteAndAccepted) {
      return this.$gettext('This results report is complete and approved.')
    }
    return this.$gettext('Draft')
  }
}
